
"use strict";


/**
 * @type Controller
 * @name RundownDialogCtrl
 * @packageName rundown_dialog_ctrl.js
 *
 * @description
 *
 * The `RundownDialogCtrl` interaction delete mdDialog for rundown
 *
 */
class RundownDialogCtrl {
	
    constructor( $scope, $mdDialog, $mdToast, $http) {
		
    	this.$mdDialog = $mdDialog;
		this.$mdToast = $mdToast;
		
    	$scope.cancel = () => {
			this.$mdDialog.hide();
    	};
		
    	$scope.sendRequest = (data) => {
			$http.post('/organisation/radiodnsrequest', data).then((result) => {
				this.$mdToast.show({
					templateUrl: '/partial/app.partials.toasts.object_saved?object=RadioDNS',
					hideDelay: 6000,
					position: ('top right')
				});
				this.$mdDialog.hide();
			}, () => {
				$scope.error = "Unable_to_send_email";
			});
    	};
		
		$http.get('/organisation/radiodnsstations').then((result) => {
			$scope.data = result.data;
		}, (result) => {
			$scope.error = result.data.error;
		});
	}
}

RundownDialogCtrl.$inject = ['$scope', '$mdDialog', '$mdToast', '$http'];

module.exports = RundownDialogCtrl;
